export default function set(name, value, minutes, base64Encoded, domain, secure) {
    if (base64Encoded === void 0) { base64Encoded = false; }
    var now = new Date();
    now.setTime(now.getTime() + minutes * 60 * 1000);
    document.cookie = name + "=" + (base64Encoded ? btoa(String(value)) : value) + ";expires=" + now.toUTCString() + ";path=/;" + (domain ? "domain=" + domain + ";" : "") + (secure ? "Secure;" : "");
}
